import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm1ViewArtistInputFieldName =
  ['music_album_artists', number, 'name'|'name_kana'|'name_en'];
type MusicAlbumEditForm1ViewArtistInputItemName =
  'music_album_artists';

/**
 * アーティスト名入力
 */
export default function MusicAlbumEditForm1ViewArtistInput({
  getNumberOfItems,
  addItem,
  getValue,
  setValue,
  getErrors,
} : {
  getNumberOfItems: (name: MusicAlbumEditForm1ViewArtistInputItemName) => number,
  addItem: (name: MusicAlbumEditForm1ViewArtistInputItemName) => void,
  getValue: (name: MusicAlbumEditForm1ViewArtistInputFieldName) => string,
  setValue: (name: MusicAlbumEditForm1ViewArtistInputFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm1ViewArtistInputFieldName) => FieldValidationErrorsType,
}) {
  return (
    <>
      {[...Array(getNumberOfItems('music_album_artists')).keys()].map((index) => (
        <React.Fragment
          // eslint-disable-next-line react/no-array-index-key
          key={index}
        >
          <dl style={{ borderTop: '1px dashed #c5c5c5', padding: '20px 0', marginBottom: '30px' }}>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">アーティスト名</label>
            </dt>
            <dd>
              <CustomTextInput
                placeholder="Frekul Band"
                value={getValue(['music_album_artists', index, 'name'])}
                setValue={(value) => setValue(['music_album_artists', index, 'name'], value)}
                validationErrors={getErrors(['music_album_artists', index, 'name'])}
              />
              <p className="text_info_on">
                すでに配信中の作品がある場合、完全に同じ表記で入力するようにしてください。ひらがな、英語も同様です。
                <br />
                異なる表記を入力した場合、配信先で同じアーティストとして表示されない可能性があります。
                <br />
                また、VOCALOIDの名称は使用できません。
              </p>
            </dd>
          </dl>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">アーティスト名読み（ひらがな）</label>
            </dt>
            <dd>
              <CustomTextInput
                placeholder="ふりくるばんど"
                value={getValue(['music_album_artists', index, 'name_kana'])}
                setValue={(value) => setValue(['music_album_artists', index, 'name_kana'], value)}
                validationErrors={getErrors(['music_album_artists', index, 'name_kana'])}
              />
              <p className="text_info_off">ここに説明文</p>
            </dd>
          </dl>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">アーティスト名（英語）</label>
            </dt>
            <dd>
              <CustomTextInput
                placeholder="Frekul Band"
                value={getValue(['music_album_artists', index, 'name_en'])}
                // eslint-disable-next-line max-len
                setValue={(value) => setValue(['music_album_artists', index, 'name_en'], value)}
                validationErrors={getErrors(['music_album_artists', index, 'name_en'])}
              />
              <p className="text_info_off">ここに説明文</p>
            </dd>
          </dl>
        </React.Fragment>
      ))}
      {getNumberOfItems('music_album_artists') < 3 && (
        <dl style={{ borderBottom: '1px dashed #c5c5c5', padding: '20px 0', marginBottom: '30px' }}>
          <dd>
            <p className="text_info_on mb5">複数名の場合は必ず、以下より入力欄を追加してください。</p>
            <CustomButton type="add" onClick={() => addItem('music_album_artists')}>
              アーティストの追加
            </CustomButton>
          </dd>
        </dl>
      )}
    </>
  );
}
